// extracted by mini-css-extract-plugin
module.exports = {"label":"StepTree_Summary_label__trSZ0","client":"StepTree_Summary_client__6xcVM","btn":"StepTree_Summary_btn__24rIs","question":"StepTree_Summary_question__1PUUd"};